import { IFieldStructure } from 'constants/valuesInterfaces/interfaces'

export const stockFields: Array<IFieldStructure> = [
	{
		idCampo: 'product_name',
		descrip: '',
		label: 'Producto',
		mascara: '',
		editable: 1,
		visible: 1,
		requerido: 0,
		valid: null,
		agrupador: ''
	},
	{
		idCampo: 'product_presentation',
		descrip: '',
		label: 'Presentacion',
		mascara: '',
		editable: 1,
		visible: 1,
		requerido: 0,
		valid: null,
		agrupador: ''
	},
	{
		idCampo: 'product_filtro',
		descrip: '',
		label: false,
		mascara: '',
		editable: 1,
		visible: 1,
		requerido: 0,
		valid: null,
		agrupador: ''
	}
]

export const optionShow: Array<{ id: string; label: string }> = [
	{
		id: 'T',
		label: 'Todos'
	},
	{
		id: 'A',
		label: 'Afectados'
	},
	{
		id: 'P',
		label: 'Pendientes'
	}
]
